export default __webpack_public_path__ + "static/media/Layer 1.3b657447.png";